import { useEffect, useState } from "react";
import { API_BASE } from "./api";

/**
 * Fetches the Hero Pulse `videos` block and returns the entry for the
 * requested surface (`home` or `money`). Values default to sensible
 * copy when the CMS hasn't been populated yet or the request fails —
 * this way the component still renders a functional lightbox with a
 * "COMING SHORTLY" poster even offline.
 */
const DEFAULTS = {
  home: {
    enabled: true,
    url: "",
    title: "How VenturaZ works — in 90 seconds",
    duration: "1:32",
    description: "A quick tour of the founder + investor journeys.",
  },
  money: {
    enabled: true,
    url: "",
    title: "How VenturaZ Money works — in 90 seconds",
    duration: "1:24",
    description: "See how we compare 85+ lenders and get you the best rate — in a single visit.",
  },
};

export function useHeroVideoConfig(surface = "home") {
  const [cfg, setCfg] = useState(DEFAULTS[surface] || DEFAULTS.home);
  useEffect(() => {
    let mounted = true;
    fetch(`${API_BASE}/public/hero-pulse`)
      .then((r) => r.json())
      .then((d) => {
        if (!mounted) return;
        const entry = (d?.videos && d.videos[surface]) || null;
        if (entry) setCfg({ ...DEFAULTS[surface], ...entry });
      })
      .catch(() => {});
    return () => { mounted = false; };
  }, [surface]);
  return cfg;
}
